<template>
    <div class="mb-6 mt-8">
        <!-- Commission Block Header -->
        <div class="mb-4">
            <h3 class="text-h6 font-weight-medium text-grey-darken-2">
                {{ commissionPercentage }}% {{ $t('commission_block.title') }}
            </h3>
        </div>

        <!-- Benefits List -->
        <div v-if="false" class="mb-4">
            <div class="d-flex align-center mb-2">
                <v-icon color="green" class="mr-3">mdi-check</v-icon>
                <span class="text-body-1 text-grey-darken-1">{{ $t('commission_block.help_24_7') }}</span>
            </div>
            <div class="d-flex align-center mb-2">
                <v-icon color="green" class="mr-3">mdi-check</v-icon>
                <span class="text-body-1 text-grey-darken-1">{{ $t('commission_block.auto_confirmed_bookings') }}</span>
            </div>
            <div class="d-flex align-center mb-2">
                <v-icon color="green" class="mr-3">mdi-check</v-icon>
                <span class="text-body-1 text-grey-darken-1">{{ $t('commission_block.google_promotion') }}</span>
            </div>
            <div class="d-flex align-center mb-2">
                <v-icon color="green" class="mr-3">mdi-check</v-icon>
                <span class="text-body-1 text-grey-darken-1">{{ $t('commission_block.payment_handling') }}</span>
            </div>
        </div>

        <!-- Divider Line -->
        <v-divider class="mb-4" />

        <!-- Earnings Display -->
        <div v-if="calculatedEarnings !== null" class="d-flex align-center">
            <span class="text-h6 font-weight-bold text-green">
                €{{ calculatedEarnings.toFixed(2) }} {{ $t('commission_block.your_earnings') }}
            </span>
        </div>

        <!-- No Rates Message -->
        <div v-else class="text-body-1 text-grey-darken-1">
            <p v-if="$i18n.locale === 'el'" class="font-italic">{{ $t('commission_block.no_rates_message_greek') }}</p>
            <p v-else>{{ $t('commission_block.no_rates_message') }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps<{
        commissionPercentage: number
        calculatedEarnings: number | null
    }>()

    const {t} = useI18n()
</script>
